import React, { ReactNode, useMemo } from 'react';
import {
    RootEditActionsContext,
    RootEditDispatchContext,
    RootEditStateContext,
    RootEditState,
    RootEditActions,
    RootEditAction,
} from './RootEditProvider.context';

const noopState: RootEditState = {
    activeEditKey: null,
    activeIsDirty: false,
    guard: { isOpen: false, intent: null, isWorking: false },
};

export default function RootEditProviderNoop({
    children,
}: {
    children: ReactNode;
}) {
    const actions = useMemo<RootEditActions>(
        () => ({
            requestActivateEdit: () => {},
            setActiveController: () => {},
            getActiveController: () => null,
            guardNavigateLink: (_to, proceed) => {
                void proceed();
            },
            guardUiAction: (_target, proceed) => {
                void proceed();
            },
            setPendingProceed: () => {},
            getPendingProceed: () => null,
            clearPendingProceed: () => {},
        }),
        [],
    );

    const dispatch = useMemo(() => {
        const noopDispatch = (_action: RootEditAction) => {};
        return noopDispatch;
    }, []);

    return (
        <RootEditStateContext.Provider value={noopState}>
            <RootEditDispatchContext.Provider value={dispatch}>
                <RootEditActionsContext.Provider value={actions}>
                    {children}
                </RootEditActionsContext.Provider>
            </RootEditDispatchContext.Provider>
        </RootEditStateContext.Provider>
    );
}
